<template>
  <div>
    <commBanner :obj="obj"></commBanner>
    <titleHead :headTitle="headTitle"></titleHead>
    <div class="w80 mb-60">
      <el-container>
        <el-aside width="330px">
          <sidebar></sidebar>
        </el-aside>
        <el-main>
          <companySide
            v-if="type"
            @isButton="isButton"
            @release="gorelease()"
          ></companySide>
          <headSide v-else @release="gorelease()"></headSide>

          <div class="mt-30">
            <!-- <div class="fsc head">
              <span>用户级别&nbsp;:</span><span>&nbsp;&nbsp;付费会员</span>
              <img class="ml-5" src="../../assets/images/grade.jpg" alt="" />
            </div> -->
            <contTitle :obj="obj" :contTitle="contTitle"></contTitle>
            <div>
              <div class="member fca mt-20">
                <span v-if="personal" @click="onPersonal()">升级个人V会员</span>
                <span v-if="expert" @click="onExpert()">升级为专家</span>
                <span v-if="compeny" @click="onCorporate()">升级为企业会员</span>
              </div>
              <div class="table">
                <moreTable :list="list" class="mt-30" v-if="show"></moreTable>
                <div v-else class="info_form mt-30">
                  <el-form ref="form" :rules="rules" :model="form" label-width="110px">
                    <!-- <h4>升级V会员完善个人信息</h4> -->
                    <el-form-item label="个人姓名 :" prop="realname" style="width: 80%">
                      <el-input v-model="form.realname" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="身份证号 :" prop="id_number" style="width: 80%">
                      <el-input
                        v-model="form.id_number"
                        maxlength="18"
                        clearable
                      ></el-input>
                    </el-form-item>
                    <div class="form_box">
                      <span>身份证正面照 :</span>
                      <div class="ml-10">
                        <el-upload
                          list-type="picture-card"
                          :headers="{ token: token }"
                          action="/api/zwb/app/oss/public/upload"
                          :on-success="onSuccess"
                          :before-upload="handlePreview"
                          :limit="1"
                        >
                          <p>选择照片</p>
                          <el-dialog :visible.sync="dialogVisible">
                            <img width="100%" :src="dialogImageUrl" alt="" />
                          </el-dialog>
                        </el-upload>
                      </div>
                    </div>
                    <div class="form_box mt-20">
                      <span>身份证反面照 :</span>
                      <div class="ml-10">
                        <el-upload
                          list-type="picture-card"
                          :headers="{ token: token }"
                          action="/api/zwb/app/oss/public/upload"
                          :on-success="handleSuccess"
                          :before-upload="handlePreview"
                          :limit="1"
                        >
                          <!-- <i slot="default" class="el-icon-plus"></i> -->
                          <p>选择照片</p>
                          <el-dialog :visible.sync="dialogVisible">
                            <img width="100%" :src="dialogImageUrl" alt="" />
                          </el-dialog>
                        </el-upload>
                      </div>
                    </div>
                    <el-form-item label="支付宝账号 :" style="width: 80%">
                      <el-input v-model="form.alipayNumber" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="微信账号 :" style="width: 80%">
                      <el-input v-model="form.weChatNumber" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="开户银行 :" style="width: 80%">
                      <el-input v-model="form.backDeposit" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="银行账户 :" style="width: 80%">
                      <el-input v-model="form.backAccount" clearable></el-input>
                    </el-form-item>

                    <p class="remarks">
                      备注：账号信息用于平台返现提现账号，智污邦平台会严格保存您的账号信息
                    </p>

                    <div class="member_box">
                        <el-form-item  prop="agree" class="fuck">
                           <el-checkbox v-model="form.agree" name="checked"></el-checkbox>
                           <div style="margin-left: 5px">
                            我已阅读并同意《
                            <span class="agree" @click="settChange()">{{agrTex}}</span>
                            》
                            </div>
                        </el-form-item>

                    </div>

                    <div class="tel">
                      <button @click.prevent="onSubmit('form')" class="upgrade">
                        提交资料
                      </button>
                    </div>
                  </el-form>
                </div>


                <!--缴费弹框-->
                <div class="dialog_from">
                      <el-dialog title="升级费用" :visible.sync="dialogFormVisible">
                      <el-form :model="retForm" ref="retForm" :rules="rules">
                        <div class="mert_dialog">
                            <div class="mert_bater fjs">
                              <p>类型: {{ vipObj.content }}</p>
                              <p class="mert_price">
                                <span> 价格:</span>
                                <span>￥{{ vipObj.cvalue }}</span>
                              </p>
                            </div>
                        </div>
                        <el-form-item label="升级类型 :" prop="amount" style="width: 80%">
                          <p>{{vipObj.content}}</p>
                        </el-form-item>
                        <el-form-item  prop="agree" class="fuck">
                           <el-checkbox v-model="retForm.agree" name="checked"></el-checkbox>
                           <div style="margin-left: 5px">我已阅读并同意《<span class="agree" @click="PayChange()">缴费协议</span>》</div>
                        </el-form-item>
                      </el-form>
                      <div slot="footer" class="dialog-footer">
                        <el-button type="primary" @click="submitForm('retForm')"
                          >确 定</el-button
                        >
                        <el-button class="footer_buts" @click="dialogFormVisible = false"
                          >取 消</el-button
                        >
                      </div>
                   </el-dialog>
                </div>

              </div>
            </div>
          </div>
        </el-main>
      </el-container>

      <!--平台会员协议弹框-->
      <div class="sett_dialog" v-show="dialogTableVisible">
        <div class="sett_cox"></div>
        <div class="sett_dialog_box">
          <div class="sett_matter">
            <p class="sett_title">{{agrTex}}</p>
            <p class="sett_jitr">
              <span v-if="!isImg">{{ time }}s</span>
              <img
                v-show="isImg"
                src="../../assets/images/sign.png"
                @click.prevent="onText()"
              />
            </p>
          </div>
          <div class="sett_desc" v-if="agrTex == '平台会员协议'"   v-html="membershipAgreement.des"></div>
          <div class="sett_desc" v-else   v-html="expertAgreement.des"></div>
        </div>
      </div>


      <!--缴费协议弹框-->
      <div class="sett_dialog z-2002" v-show="dialogPay">
        <div class="sett_cox"></div>
        <div class="sett_dialog_box">
          <div class="sett_matter">
            <p class="sett_title">缴费协议</p>
            <p class="sett_jitr">
              <span v-if="!payImg">{{ payTime }}s</span>
              <img
                v-show="payImg"
                src="../../assets/images/sign.png"
                @click.prevent="onText()"
              />
            </p>
          </div>
          <div class="sett_desc"  v-html="payAgreemant.des"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  member,
  getVip,
  createorder,
  upvip,
  existchangtypelog,
  changtype,
  orderinfo,
  agreement,
} from "@/api/coment";
import { getToken } from "@/utils/auth";
import sidebar from "../../common/sidebar";
import headSide from "../../common/headSide";
import companySide from "../../common/companySide";
import commBanner from "../../common/commBanner";
import titleHead from "../../common/titleHead";
import contTitle from "../../common/contTitle";
import moreTable from "../../components/moreTable";
import info_detailVue from "../industry_information/info_detail.vue";
export default {
  components: {
    sidebar,
    headSide,
    companySide,
    commBanner,
    titleHead,
    contTitle,
    moreTable,
  },
  data() {
    //身份证校验
    var cardId = (rule, value, callback) => {
      const regCard = /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/;
      if (regCard.test(value)) {
        return callback();
      }
      callback(new Error("请输入合法的身份证号"));
    };
    //银行卡号
    var cardNum = (rule, value, callback) => {
      const regCardNum = /^([1-9]{1})(\d{14}|\d{18})$/;
      if (regCardNum.test(value)) {
        return callback();
      }
      callback(new Error("请输入合法的银行卡号"));
    };

    return {
      membershipAgreement: "",
      expertAgreement:'',
      payAgreemant:'',
      isImg: false,
      time: 10,
      payTime:10,
      payImg:false,
      dialogTableVisible: false,
      contTitle: "智污邦环保管家会员权益",
      headTitle: "会员权益",
      obj: {
        title: "会员权益",
        isShow: false,
        roleType: "",
        personalType: 9,
      },
      show: true,
      form: {
        realname: "", //姓名
        id_number: "", //身份号
        alipay: "", //支付宝
        wxpay: "", //微信号
        id_back: "", //反面
        id_front: "", //正面
        bank_name: "", //开户银行
        bank_code: "", //开户账号
        bank_name: "",
        agree:''
      },
      rules: {
        realname: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        id_number: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          { validator: cardId, trigger: "blur" },
        ],
        alipay: [{ required: true, message: "请输支付宝账号", trigger: "blur" }],
        wxpay: [{ required: true, message: "请输入微信账号", trigger: "blur" }],
        bank_name: [{ required: true, message: "请输入开户银行", trigger: "blur" }],
        bank_code: [
          { required: true, message: "请输入开户账号", trigger: "blur" },
          { validator: cardNum, message: "请输入正确的银行卡号", trigger: "blur" },
        ],
       agree: [{ required: true, message: "请接受智污邦专家入驻协议",trigger: "change"}],
      },
      dialogImageUrl: "",
      disabled: false,
      dialogVisible: false,
      // userShow:true,
      token: getToken(),
      personal: true, //个人
      expert: true, //专家
      compeny: true, //企业
      toMer: false,
      dialogFormVisible: false,
      vipObj:{},
      list: [],
      data: [], //储存会员处理数据
      info: [],
      formLabelWidth: "120px",
      retForm: {
        amount: "",
        goodsId: "",
        goodsType: 1000,
        agree:''
      },
      rules:{
          agree: [{ required: true, message: "请接受智污邦缴费协议",trigger: "change"}]
      },
      dialogPay:false,
      type: false,
      isButton: false,
      agrTex:'平台会员协议'
    };
  },
  created() {

    this.getAgreement();
    let str = this.$route.query.type;
    if (str != undefined) {
      this.show = false;
    }

    let type = this.$store.state.user.userInfo.type;
    let obj = this.$store.state.user.userInfo.data2;
    this.obj.roleType = type;
    if(type == 3){
      this.type = true;
      this.personal = false;
      this.expert = false;
    }
    switch (obj.id) {
      case 3:
        this.expert = false;
        this.compeny = true;
        this.personal = false;
        break;
      case 4:
        this.compeny = true;
        break;
      case 5:
        this.compeny = false;
        break;
    }
  },
  methods: {
    //升级个人vip
    onPersonal() {
      if(this.$store.state.user.userInfo.data.status == 1){
        //this.getUpvip(0);
        this.getVip(0);
        this.dialogFormVisible = true;
      }else{
        this.show = false;
      }
    },
    //升级专家
    onExpert() {
      this.getVip(1);
      this.show = false;
      this.toMer = true;
      this.agrTex = '专家入驻协议'
    },
    //升级企业
    onCorporate() {
      //升级企业账户
      this.getVip(2);
      if(this.$store.state.user.userInfo.data.status == 1){
        this.$router.push("/corporate_attestation");
      }else{
        this.$message({
          message:'认证通过后，才能升级哦!',
          type:'info',
          duration:2000
        });
      }

    },
    getAgreement() {
      agreement()
        .then((res) => {
          this.membershipAgreement = res.page.filter(
            (item) => item.name == "平台会员协议"
          )[0];
          this.expertAgreement = res.page.filter(
            (item) => item.name == "专家入驻协议"
          )[0];
          this.payAgreemant = res.page.filter(
            (item) => item.name == '缴费协议'
          )[0];
        })
        .catch((err) => {});
    },
    settChange() {
      this.dialogTableVisible = true;
      this.timer = setInterval(() => {
        this.time--;
        if (this.time == 0) {
          clearInterval(this.timer);
          this.isImg = true;
        }
      }, 1000);
    },
    PayChange(){
      this.dialogPay = true;
      this.timers = setInterval(() => {
        this.payTime--;
        if (this.payTime == 0) {
          clearInterval(this.timers);
          this.payImg = true;
        }
      }, 1000);
    },
    onText() {
      this.dialogTableVisible = false;
      this.dialogPay = false;
    },
    handleRemove(file) {},
    //升级vip缴纳保证金
    getVip(page_id) {
      getVip()
        .then((res) => {
          if (res.code == 0) {
              this.vipObj = res.page[page_id];
            //this.vipObj = res.page[0];
          }
        })
        .catch((err) => {});
    },
    //立即升级
    onSubmit(formName) {
      if (this.toMer == true) {
        //专家
        this.$refs[formName].validate((valid) => {
          if (valid) {
            member(this.form)
              .then((res) => {
                if (res.code == 0) {
                  this.$message({
                    message: "等待审核",
                    type: "info",
                    duration: 3000,
                  });
                  this.getChangtype(2);
                }
              })
              .catch((err) => {});
          } else {
            return false;
          }
        });
      } else {
        //个人
        this.$refs[formName].validate((valid) => {
          if (valid) {
            member(this.form)
              .then((res) => {
                if (res.code == 0) {
                   this.$message({
                     message:'等待审核...',
                     type:'warning',
                     duration:2000
                   })
                }
              })
              .catch((err) => {});
          } else {
            return false;
          }
        });
      }
    },
    //文件上传成功返回
    onSuccess(res) {
      if (res.code == 0) {
        this.$message({
          //正面
          message: "上传成功！",
          type: "success",
        });
        this.dialogImageUrl = res.url;
        this.form.id_front = res.url;
      }
    },
    handleSuccess(res) {
      if (res.code == 0) {
        this.$message({
          //反面
          message: "上传成功！",
          type: "success",
        });
        this.dialogImageUrl = res.url;
        this.form.id_back = res.url;
      }
    },
    handlePreview(file) {
      //上传前对图片类型和大小进行判断
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg";
      const isLt3M = file.size / 1024 / 1024 < 3;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG,PNG 格式!");
      }
      if (!isLt3M) {
        this.$message.error("上传头像图片大小不能超过 3MB!");
      }
      return isJPG && isLt3M;
    },
    //发布需求
    gorelease() {
      this.$router.push("/demand");
    },
    //数据去重
    repeat(data) {
      const row = [];
      data.forEach((e) => {
        let index = row.findIndex((arr) => {
          return e.authId == arr.authId;
        });
        if (index == -1) {
          row.push(e);
        }
      });
      this.list = row;
      return row;
    },
    //会员缴费
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let postData = {
            amount:this.vipObj.cvalue,
            goodsId:this.vipObj.id,
            goodsType:1000
          };
          createorder(postData)
            .then((res) => {
              if (res.code == 0) {
                if (res.data.amount != 0) {
                  localStorage.setItem("list", JSON.stringify(res.data));
                  this.$router.push({
                    path: "/payment",
                  });
                } else {
                  this.dialogFormVisible = false;
                  this.$message({
                    message: "等待审核",
                    type: "info",
                    duration: 3000,
                  });
                }
              }
            })
            .catch((err) => {});
        }
      });
    },
    onChange(event) {
      this.vipList.forEach((item) => {
        if (item.cvalue == event) {
          this.retForm.amount = event;
          this.retForm.goodsId = item.id;
        }
      });
    },
    //升级会员
    getUpvip(id) {
      let params = { roleid: id };
      upvip(params)
        .then((res) => {
          if (res.code == 0) {
            switch (Number(res.data.step)) {
              case 1: // 提交资料
                this.show = false;
                break;
              case 2: // 审核
                this.$message({
                  message: "资料审核完成，请及时缴费！",
                  type: "info",
                  duration: 2000,
                });
                this.getOrderinfo(res.data.msg);
                break;
              case 3: //未支付
                this.$message({
                  message: "资料审核完成，请及时缴费！",
                  type: "info",
                  duration: 2000,
                });
                this.getOrderinfo(res.data.msg);
                break;
            }
          }
        })
        .catch((err) => {});
    },
    //查询订单信息
    getOrderinfo(info) {
      let prams = { orderno: info };
      orderinfo(prams)
        .then((res) => {
          if (res.code == 0) {
            localStorage.setItem("list", JSON.stringify(res.data));
            this.$router.push("/payment");
          }
        })
        .catch((err) => {});
    },
    //升级用户类型
    getChangtype(data) {
      let params = { type: data };
      changtype(params)
        .then((res) => {
          if (res.code == 0) {
            if (res.data.msg == null && res.data.step == "1") {
              // this.$message({
              //    message:'审核未通过',
              //    type:'info',
              //    duration:3000
              // })
            } else {
            }
            //  switch(Number(res.data.content)){
            //    case 2:
            //      this.show = false
            //     break;
            //    case 3:
            //     this.$router.push('/corporate_attestation');
            //     break;
            //  }
          }
        })
        .catch((err) => {});
    },
  },
};
</script>
<style scoped>
/deep/ .el-table__header {
  width: 100% !important;
}
/deep/ .el-table__body {
  width: 100% !important;
}
.head {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
  margin-bottom: 30px;
}
.member span:hover {
  cursor: pointer;
}
.member span:first-child {
  width: 196px;
  height: 36px;
  line-height: 36px;
  color: white;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  background: linear-gradient(-58deg, #bfd817, #68be32);
}
.member span:nth-child(2) {
  width: 196px;
  height: 36px;
  line-height: 36px;
  color: white;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  background: linear-gradient(106deg, #18bbe9, #2866d2);
}
.member span:nth-child(3) {
  width: 196px;
  height: 36px;
  line-height: 36px;
  color: white;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  background: linear-gradient(-58deg, #ffba01, #ff9200, #ff6e01);
}
.info_form h4 {
  margin: 20px 0px;
  font-size: 20px;
}
.info_form >>> .el-form-item {
  margin-top: 20px;
}
.form_box {
  display: flex;
  justify-content: flex-start;
}
.form_box p {
  font-size: 14px;
  color: #606266;
}
.form_box span {
  font-size: 14px;
  color: #606266;
  margin-left: 33px;
}
.remarks {
  text-align: left;
  margin-left: 30px;
  font-size: 14px;
}
.upgrade {
  width: 108px;
  height: 35px;
  background: #3bbb35;
  border-radius: 3px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  margin-left: 30px;
  margin-top: 40px;
}
.mb-60 {
  margin-bottom: 60px;
}
.z-2002{
  z-index: 2002 !important;
}
.mt-20 {
  margin-top: 20px;
}
.ml-5 {
  margin-left: 5px;
}
.ml-10 {
  margin-left: 10px;
}
.fjs {
  display: flex;
  justify-content: flex-start;
}
.mert_dialog {
  margin-bottom: 20px;
}
.mert_form {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}
.mert_bater {
  margin-top: 30px;
  margin-left: 30px;
  text-align: left;
}
.mert_bater p {
  font-size: 14px;
}
.mert_bater p:nth-child(1) {
  width: 200px;
}
.mert_price {
  margin-left: 20px;
  /* color:rgb(255, 116, 2); */
  font-size: 16px;
}
.mert_price span:nth-child(2) {
  color: rgb(255, 116, 2);
  font-size: 16px;
}
/deep/.dialog-footer {
  text-align: left;
  margin-left: 30px;
}
/deep/.el-button {
  width: 129px;
  height: 35px;
  /* border: none; */
}
/deep/.el-button--primary {
  background: #3bbb35;
  border: none;
}
.footer_buts:hover {
  background: #fff;
  color: #000;
  border-color: #ebebeb;
}
.el-form-item {
  margin-left: 30px;
}

.dialog_from >>>.el-dialog{
  width: 480px !important;
  height: 350px !important;
}
.dialog_from >>>.el-dialog__footer{
  margin-top: -41px;
}

/**协议弹框 */
.sett_dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  margin: 0;
  z-index: 999;
}
.sett_dialog_box {
  width: 500px;
  height: 600px;
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 3px;
  transform: translate(-50%, -50%);
  background: #ffffff;
  overflow: auto;
}
.sett_cox {
  position: fixed;
  left: 0;
  /* opacity: 0.3; */
  width: 100%;
  height: 100%;
  top: 0;
  background-color: rgba(0, 0, 0, 0.8);
  /* z-index:2003 !important; */
}
.sett_matter {
  position: relative;
  height: 50px;
}
.sett_title {
  font-size: 22px;
  color: #666666;
  height: 30px;
  line-height: 48px;
  text-align: center;
}
.sett_jitr {
  position: absolute;
  right: 20px;
  top: 10px;
}
.sett_jitr img {
  width: 20px;
  height: 20px;
}



.sett_dialog >>> .el-dialog {
  width: 500px;
  height: 600px;
}
.sett_dialog >>> .el-dialog__header {
  text-align: center;
}
.sett_dialog >>> .el-dialog__title {
  font-size: 24px;
}
.sett_desc {
  padding: 30px;
  font-size: 14px;
  line-height: 24px;
  color: #666666;
}
/deep/ .fuck .el-form-item__content {
  display: flex;
  align-items: center;
  margin-left: 0px !important;
}
.agree {
  cursor: pointer;
  color: #69cc1e;
}
.agree:hover {
   text-decoration: underline;
}

.member_box{
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/view/coment/membership.vue